import {BASE_URL_CLIENT} from "~/constants/api/base.js";

export const LEGAL_ENTITIES = `${BASE_URL_CLIENT}/legal-entities`;
export const LEGAL_ENTITY = `${LEGAL_ENTITIES}/:id`;

export const PAYMENTS = `${BASE_URL_CLIENT}/payment`;
export const CARDS = `${PAYMENTS}/cards`;
export const CARD = `${CARDS}/:id`;
export const PAYMENT_DATA = `${PAYMENTS}/get-payments`;
export const PAYMENT_INFO_CLIENTS_EMPLOYEE = `${PAYMENTS}/info`;
export const API_PAYMENT_BONUSES = `${PAYMENTS}/bonuses`;